import { useTranslation } from 'react-i18next'
import { Plus, Sparkles } from 'lucide-react'

import { Button } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'

interface ListingBuilderOverviewHeaderProps {
  onNewAudit: () => void
}

export function ListingBuilderOverviewHeader({ onNewAudit }: ListingBuilderOverviewHeaderProps) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 p-3 shadow-lg shadow-orange-500/30">
          <Sparkles className="h-6 w-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-neutral-900 dark:text-white">
            {t('listingBuilder.title')}
          </h1>
          <p className="mt-1 text-sm text-neutral-500 dark:text-neutral-400">
            {t('listingBuilder.overview.subtitle')}
          </p>
        </div>
      </div>
      <Button id={EID['listing-builder-new-audit-btn']} type="button" onClick={onNewAudit}>
        <Plus className="mr-1 h-4 w-4" />
        {t('listingBuilder.overview.newAudit')}
      </Button>
    </div>
  )
}
